export const conditionsData = [
  {
    id: "enlarged-prostate",
    name: "Enlarged Prostate",
    category: "Prostate Health",
    stat: "50% of men over 50",
    shortDescription:
      "Benign prostatic hyperplasia (BPH) causes the prostate gland to enlarge, leading to urinary symptoms. We offer comprehensive evaluation and personalized treatment options.",
    longDescription:
      "Benign prostatic hyperplasia (BPH) causes the prostate gland to enlarge, leading to urinary symptoms such as frequency, urgency, weak stream, and nighttime urination. We offer comprehensive evaluation and personalized treatment options to improve your quality of life.",
    commonSymptoms: [
      "Frequent urination",
      "Weak urine stream",
      "Difficulty starting urination",
      "Incomplete bladder emptying",
      "Nighttime urination",
    ],
    treatmentOptions: [
      "Lifestyle modifications",
      "Prescribed medications",
      "Combination therapies",
      "Minimally invasive procedures",
      "Surgery",
    ],
  },
  {
    id: "overactive-bladder",
    name: "Overactive Bladder",
    category: "Bladder Health",
    stat: "Up to 40% of adults",
    shortDescription:
      "Sudden, intense urges to urinate that are difficult to control. Our evidence-based treatments help restore normal bladder function and confidence.",
    longDescription:
      "Overactive bladder causes sudden, intense urges to urinate that are difficult to control. You may urinate frequently, wake up at night, or experience leakage. Our evidence-based treatments help restore normal bladder function and confidence.",
    commonSymptoms: [
      "Sudden urge to urinate",
      "Frequent urination",
      "Urge incontinence",
      "Nighttime urination",
      "Pelvic pressure",
    ],
    treatmentOptions: [
      "Lifestyle modifications",
      "Prescribed medications",
      "Combination therapies",
      "Minimally invasive procedures",
      "Surgery",
    ],
  },
  {
    id: "erectile-dysfunction",
    name: "Erectile Dysfunction",
    category: "Sexual Health",
    stat: "40% of men in their 40s",
    shortDescription:
      "Difficulty achieving or maintaining an erection sufficient for sexual activity. We provide discreet, comprehensive care with proven treatment options.",
    longDescription:
      "Erectile dysfunction is the persistent difficulty achieving or maintaining an erection firm enough for sexual activity. We provide discreet, comprehensive evaluation and treatment options tailored to your goals.",
    commonSymptoms: [
      "Difficulty achieving an erection",
      "Trouble maintaining an erection",
      "Reduced sexual desire",
      "Performance anxiety",
    ],
    treatmentOptions: [
      "Lifestyle and risk-factor modification",
      "Oral medications",
      "Injectable therapies",
      "Vacuum erection devices",
      "Surgical options when needed",
    ],
  },
  {
    id: "recurrent-utis",
    name: "Recurrent UTIs",
    category: "Urinary Health",
    stat: "25% of women experience recurrence",
    shortDescription:
      "Frequent urinary tract infections that significantly impact quality of life. We identify underlying causes and develop prevention strategies.",
    longDescription:
      "Recurrent urinary tract infections can significantly disrupt daily life. We identify underlying causes, review prior testing, and create a personalized plan to reduce recurrences.",
    commonSymptoms: [
      "Burning with urination",
      "Frequent urination in small amounts",
      "Pelvic discomfort",
      "Blood in the urine",
      "Recurrent infections within months",
    ],
    treatmentOptions: [
      "Targeted antibiotics when needed",
      "Bladder health counseling",
      "Preventive medications",
      "Vaginal estrogen (when appropriate)",
      "Behavioral strategies and lifestyle support",
    ],
  },
  {
    id: "recurrent-kidney-stones",
    name: "Recurrent Kidney Stones",
    category: "Kidney Health",
    stat: "1 in 3 will have another stone within 10 years",
    shortDescription:
      "Repeated formation of kidney stones causing pain and urinary complications. We focus on prevention strategies and effective stone management.",
    longDescription:
      "Repeated formation of kidney stones can cause severe pain and long-term kidney issues. We evaluate stone type, metabolic risk factors, and design a plan to prevent future stones.",
    commonSymptoms: [
      "Severe flank or side pain",
      "Blood in the urine",
      "Nausea or vomiting",
      "Urinary urgency or discomfort",
      "History of passing stones or needing procedures",
    ],
    treatmentOptions: [
      "Stone-type analysis and lab evaluation",
      "Fluid and dietary recommendations",
      "Preventive medications",
      "Shock-wave lithotripsy or ureteroscopy",
      "Long-term monitoring",
    ],
  },
  {
    id: "premature-ejaculation",
    name: "Premature Ejaculation",
    category: "Sexual Health",
    stat: "20–30% of men",
    shortDescription:
      "Ejaculation that occurs sooner than desired during sexual activity. Our specialized treatments help improve sexual satisfaction and confidence.",
    longDescription:
      "Premature ejaculation is ejaculation that happens sooner than desired during sexual activity. We evaluate contributing factors and offer behavioral, medication, and counseling-based treatments.",
    commonSymptoms: [
      "Ejaculation within 1–2 minutes of penetration",
      "Difficulty delaying ejaculation",
      "Distress or frustration about timing",
      "Impact on relationship satisfaction",
    ],
    treatmentOptions: [
      "Behavioral techniques",
      "Topical therapies",
      "Oral medications",
      "Couples and sexual counseling",
    ],
  },
  {
    id: "low-testosterone",
    name: "Low Testosterone",
    category: "Hormonal Health",
    stat: "Up to 20% of men over 40",
    shortDescription:
      "Decreased testosterone levels affecting energy, mood, and sexual function. We provide comprehensive hormone evaluation and treatment.",
    longDescription:
      "Low testosterone can impact energy, mood, muscle mass, and sexual function. We perform a thorough hormonal evaluation and discuss safe, evidence-based treatment options.",
    commonSymptoms: [
      "Low energy or fatigue",
      "Decreased sex drive",
      "Erectile difficulties",
      "Loss of muscle mass",
      "Mood changes or irritability",
    ],
    treatmentOptions: [
      "Lifestyle optimization",
      "Testosterone replacement (when appropriate)",
      "Monitoring of labs and safety markers",
      "Coordination with primary care and specialists",
    ],
  },
];
